import Script from 'next/script'

type GoogleTagProps = {
  eventName: string
}

export default function GoogleTag({ eventName }: GoogleTagProps) {
  const Gname = `GTM-${eventName}`
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: `${eventName}`
  });
}